export default {
  name: 'App',
  mounted() {
    // 初始化应用
    this.$store.dispatch('app/initApp');
  }
};